import styled from 'styled-components'

export const Locations = styled.div`
  height: 100%;
  padding-bottom: 20px;

  .location-map {
    min-height: 375px;
  }

  button {
    svg {
      position: relative;
      top: -2px;
      left: 10px;
      fill: ${ (props) => props.theme.colors['panel-inner-border'] } !important;
    }
  }
`
